import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center font-semibold" }
const _hoisted_2 = { class: "text-gray-lp-500 font-normal ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, null, {
    label: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.common.vehicleSerialNumber")) + " ", 1),
        _createVNode("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t("cargoV2.components.common.other")) + ")", 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_LpInput, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
        placeholder: _ctx.$t('cargoV2.components.inputVehicleNo.placeholder'),
        format: _ctx.formatVehicleNo,
        error: _ctx.isErrorVehicleNo,
        errorCaption: _ctx.errorVehicleNo,
        isErrorIconCaption: false,
        isErrorIconInput: false,
        marginVertical: _ctx.marginVertical,
        disabled: _ctx.isEdit,
        disableBackground: _ctx.isEdit
      }, null, 8, ["modelValue", "placeholder", "format", "error", "errorCaption", "marginVertical", "disabled", "disableBackground"])
    ]),
    _: 1
  }))
}